module.exports = __webpack_public_path__ + "static/img/sand_8_max_2.6a536590.png";